import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';

// Public Pages
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// Protected Pages - Dashboard
import Dashboard from './pages/Dashboard';

// Protected Pages - Diary Management
import AllEntries from './pages/diary/AllEntries';
import EntryDetail from './pages/diary/EntryDetail';
import CreateEntry from './pages/diary/CreateEntry';
import EditEntry from './pages/diary/EditEntry';

// Protected Pages - Search
import SearchResults from './pages/search/SearchResults';

// Protected Pages - User Management
import Profile from './pages/user/Profile';
import Settings from './pages/user/Settings';

// Protected Pages - Sharing System
import ShareManagement from './pages/sharing/ShareManagement';

// Public Shared Entry View (no auth required)
import SharedEntryView from './pages/sharing/SharedEntryView';

import AnalyticsDashboard from './pages/analytics/AnalyticsDashboard';

// 404 Page
import NotFound from './pages/NotFound';

//Theme Provided
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ThemeProvider>
        <Layout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Public Shared Entry Route (no auth required) */}
            <Route path="/shared/:token" element={<SharedEntryView />} />
            
            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            
            {/* Diary Management Routes */}
            <Route
              path="/entries"
              element={
                <ProtectedRoute>
                  <AllEntries />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entries/new"
              element={
                <ProtectedRoute>
                  <CreateEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entries/:id"
              element={
                <ProtectedRoute>
                  <EntryDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entries/:id/edit"
              element={
                <ProtectedRoute>
                  <EditEntry />
                </ProtectedRoute>
              }
            />
            
            {/* Search Routes */}
            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <SearchResults />
                </ProtectedRoute>
              }
            />
            
            {/* User Management Routes */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            
            {/* Sharing System Routes */}
            <Route
              path="/shares"
              element={
                <ProtectedRoute>
                  <ShareManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <AnalyticsDashboard />
                </ProtectedRoute>
              }
            />
            
            {/* 404 Route - Must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          
          {/* Toast Notifications */}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                theme: {
                  primary: '#4aed88',
                },
              },
            }}
          />
        </Layout>
        </ThemeProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
